export default __webpack_public_path__ + "static/media/Samsung Internet.137025f6.svg";